import styled from 'styled-components';
import mediaQueries from 'constants/mediaQueries';

import { Container } from 'components/shared/container/Container.styled';
import { colorWhite, colorBrandPrimary } from 'constants/colors';

export const FlexContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const MobileContent = styled.div<{ backgroundColor?: string }>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor || colorBrandPrimary};
  ${mediaQueries.desktop} {
    display: none;
  }
`;

export const DesktopContent = styled.div<{ backgroundColor?: string }>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor || colorBrandPrimary};
  display: none;
  padding: 56px 0;

  ${mediaQueries.desktop} {
    display: block;
  }
`;

export const LinksList = styled.ul`
  margin: 0;
  padding: 0;
  flex: 1;
`;

export const Link = styled.a<{ color?: string }>`
  text-decoration: none;
  color: ${({ color }) => color || colorWhite};

  &:active,
  &:visited {
    color: ${({ color }) => color || colorWhite};
  }
`;

export const Text = styled.span<{ color?: string }>`
  color: ${({ color }) => color || colorWhite};
`;

export const HeaderLink = styled.li`
  list-style: none;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  margin: 0;

  ${mediaQueries.desktop} {
    margin: 0 0 16px 0;
  }
`;

export const FooterLink = styled.li`
  list-style: none;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  margin-bottom: 8px;

  & > a:hover {
    text-decoration: underline;
  }
`;
